import {Kpi} from '@hconnect/common/types'
import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'

import {mutations} from '@settings/api/mutations'
import {ErrorResponse} from '@settings/modules/common/types'
import {notifyIfErrorMessage} from '@settings/modules/common/utils'

export const useEditJanusKeyFigure = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()

  return useMutation<
    Kpi,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.editJanusKeyFigure>[0]
  >({
    mutationFn: mutations.editJanusKeyFigure,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.message, raiseError, notify)
    }
  })
}
